import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { calculateAge, dateFormatter } from '../../../../../utils';
import parse from 'html-react-parser';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
   page: {
    flexDirection: 'column',
    paddingHorizontal: 10,
    paddingVertical: 20
  },
  pageContent: {
    flexDirection: 'column',
    marginTop: '20%'
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px',
    borderRadius: '8px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10,
    marginTop: 5
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  row2: {
    flexDirection: 'row',
    marginBottom: 2,
    padding: '5px'
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnContent: {
    width: '25%',
    textAlign: 'center',
    alignItems: 'center',
    paddingLeft: '10%'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  boldText: {
    fontFamily: 'Roboto',
    fontSize: 6,
    fontWeight: 'ultrabold',
    fontSize: '10px',
    marginTop: '1%',
    marginLeft: '4%'
  },
  bText: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '10px'
  },
  ResultEntryText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    margin: '0 auto',
    fontWeight: 'ultrabold'
  },
  fontBold: {
    width: '25%',
    paddingLeft: '10%',
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    textDecoration: 'underline'
  },
  parsedContent: {
    marginTop: 10,
    fontSize: 10,
    textAlign: 'justify',
    padding: 10
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const ResultEntryPdf1 = ({ data }) => {
  const parseHtmlToPdfText = (html) => {
    return parse(html, {
      replace: (domNode) => {
        if (domNode.type === 'tag') {
          switch (domNode.name) {
            case 'strong':
              return <PDFText style={styles.boldText}>{domNode.children[0]?.data}</PDFText>;
            case 'p':
              return <PDFText style={styles.text}>{domNode.children.map((child) => child.data).join('')}</PDFText>;
            default:
              return <PDFText style={styles.text}>{domNode.data}</PDFText>;
          }
        }
      }
    });
  };
  const stripHtml = (html) => {
    return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
  };
  const editorContentPlainText = stripHtml(data?.editorContent || '');
  const groupedTests = data?.tests?.reduce((acc, test) => {
    const groupName = test.test_name;
    if (!acc[groupName]) {
      acc[groupName] = [];
    }
    acc[groupName].push(test);
    return acc;
  }, {});
  return (
<PDFViewer width="100%" height="100%" showToolbar>
  <Document title="Result Entry">
    {groupedTests &&
      Object.keys(groupedTests).map((testName, idx) => (
        <Page key={idx} size="A4" style={styles.page}>
          <View style={{ ...styles.pageContent, marginTop: '25%' }} wrap={true} minPresenceAhead={80}>
            {/* Patient Details Section */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, marginLeft: '1%' }}>
                <View style={styles.row}>
                  <Text content="Name               :     " style={styles.bText} />
                  <Text content={`${data?.patientName}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender    :      " style={styles.bText} />
                  <Text content={`${calculateAge(data?.age)}/${data?.gender}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Phone No.       :      " style={styles.bText} />
                  <Text content={`${data?.mobile_no}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Report Date    :      " style={styles.bText} />
                  <Text content={`${dateFormatter(data?.createdAt)}`} />
                </View>
              </View>

              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="UHID                       :     " style={styles.bText} />
                  <Text content={`${data?.uhid}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Report Id                :     " style={styles.bText} />
                  <Text content={`${data?.report_id}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Collection Date     :     " style={styles.bText} />
                  <Text content={`${dateFormatter(data?.sampleCollection?.date)}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor Advised     :     " style={styles.bText} />
                  <Text content={data?.doctor?.name} />
                </View>
              </View>
            </View>

            {/* Table Header */}
            <View style={{ ...styles.row2, width: '100%', flexDirection: 'row', marginTop: '10px' }}>
              <Text style={{ ...styles.columnHeader, width: '50%' }} content="Test Name" />
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Result" />
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Low/High" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Biological Ref. Interval" />
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Unit" />
            </View>

            {/* Test Group Title */}
            <Text
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '14px',
                fontFamily: 'Roboto',
                textDecoration: 'underline',
                marginTop: '10px',
                marginBottom: '5px'
              }}
              content={testName}
            />

            {/* Test Items */}
            {groupedTests[testName].map((test, testIndex) => (
              <View key={testIndex} style={{ flexDirection: 'row', marginBottom: '13px' }}>
                <Text
                  content={test.test_item_name || '-'}
                  style={{
                    ...styles.columnText,
                    width: '48%',
                    textAlign: 'start',
                    fontSize: '8px',
                    marginLeft: '10px'
                  }}
                />
                <Text
                  content={test.Result || '-'}
                  style={{
                    ...styles.columnText,
                    width: '10%',
                    textAlign: 'center',
                    fontFamily:
                      test.Result &&
                      test.general_from &&
                      test.general_to &&
                      test.Result >= test.general_from &&
                      test.Result <= test.general_to
                        ? ''
                        : 'Roboto',
                    fontSize: '8px'
                  }}
                />
                <Text
                  content={
                    test.Result && test.general_from && test.general_to
                      ? test.Result > test.general_to
                        ? 'H'
                        : test.Result < test.general_from
                          ? 'L'
                          : ''
                      : '-'
                  }
                  style={{
                    ...styles.columnText,
                    width: '10%',
                    textAlign: 'center',
                    fontSize: '8px'
                  }}
                />
                <Text
                  content={`${test.general_from || '-'} - ${test.general_to || '-'}`}
                  style={{
                    ...styles.columnText,
                    width: '20%',
                    textAlign: 'center',
                    fontSize: '8px'
                  }}
                />
                <Text
                  content={test.unit_name || '-'}
                  style={{
                    ...styles.columnText,
                    width: '10%',
                    textAlign: 'center',
                    fontSize: '8px'
                  }}
                />
              </View>
            ))}

            {/* Additional Parsed HTML (only on the last page) */}
            {idx === Object.keys(groupedTests).length - 1 && data?.editorContent && (
              <View style={styles.parsedContent}>
                {parseHtmlToPdfText(data.editorContent)}
              </View>
            )}
          </View>
        </Page>
      ))}
  </Document>
</PDFViewer>

  );
};
